import { useState } from "react";
import Footer from "../../component/footer";
import Navbar from "../../component/navbar";
import Fancybox from "../../component/Fancybox";

export default function PageIT() {
  const [activeTab, setActiveTab] = useState("policy"); // กำหนดสถานะเริ่มต้น

  return (
    <>
      <Navbar />
      <div className="max-w-5xl mx-auto h-screen flex flex-col justify-start items-center py-10 ">
        <div className="w-full px-5 ">
          <div className="relative flex flex-col justify-center items-center">
            <div className="h-[300px] overflow-hidden rounded-xl">
              <img
                src="https://www.cmu.ac.th/content/organization/258b8734-f5db-4af5-8a45-ea3c0124b700/0528361d-c433-4a0b-8316-df162c245f17.jpg"
                className="object-cover w-screen h-full"
                alt=""
              />
            </div>
            <div className="absolute bg-black/80 px-10 py-10 mx-5 rounded-xl">
              <h3 className=" text-[#ffffff] border-b-2 border-[#9e76b4] ">
                หน่วยกายภาพ สิ่งแวดล้อมและเทคโนโลยีสารสนเทศ
              </h3>
              <p className="text-white text-xl mt-3">นโยบาย กฎระเบียบ</p>
            </div>
          </div>

          <div className="md:px-32 md:py-10 w-full">
            <div className="border border-gray-100 bg-white rounded-xl shadow-lg p-5 flex flex-col w-full ">
              <div className=" pb-5 border-b-2 border-gray-100 flex justify-start space-x-6 text-xl font-medium">
                <button
                  className={`md:px-4 md:py-1  md:hover:bg-[#9e76b4] md:hover:text-white  ${activeTab === "policy"
                    ? "md:text-white text-[#9e76b4] md:bg-[#9e76b4] border-b-2 border-[#9e76b4] md:rounded-md rounded-none md:shadow-md"
                    : "bg-transparent"
                    }`}
                  onClick={() => setActiveTab("policy")}
                >
                  นโยบาย
                </button>
                <span className="md:block hidden text-gray-300">|</span>
                <button
                  className={`md:px-4 md:py-1  md:hover:bg-[#9e76b4] md:hover:text-white ${activeTab === "regulations"
                    ? "md:text-white text-[#9e76b4] md:bg-[#9e76b4] border-b-2 border-[#9e76b4] md:rounded-md rounded-none md:shadow-md"
                    : "bg-transparent"
                    }`}
                  onClick={() => setActiveTab("regulations")}
                >
                  ระเบียบและข้อบังคับ
                </button>
                <span className="md:block hidden text-gray-300">|</span>
                <button
                  className={`md:px-4 md:py-1  md:hover:bg-[#9e76b4] md:hover:text-white ${activeTab === "laws"
                    ? "md:text-white text-[#9e76b4] md:bg-[#9e76b4] border-b-2 border-[#9e76b4] md:rounded-md rounded-none md:shadow-md"
                    : "bg-transparent"
                    }`}
                  onClick={() => setActiveTab("laws")}
                >
                  กฎหมาย
                </button>
              </div>

              <div className="px-5 pt-3">
                <Fancybox
                  options={{
                    Toolbar: {
                      display: ["close", "download"], // แสดงเฉพาะปุ่มปิด
                    },
                    Iframe: {
                      preload: false,
                    },
                  }}
                >
                  {activeTab === "policy" && (
                    <ul className="list-disc text-[#5eafd2] font-medium ">
                      <li
                        onClick={() =>
                          window.open("/ITS/cyber-security-cmu.pdf", "_blank")
                        }
                        className="cursor-pointer"
                      >
                        นโยบายและแนวปฏิบัติในการรักษาความมั่นคงปลอดภัยไซเบอร์
                        มหาวิทยาลัยเชียงใหม่ พ.ศ. 2567
                      </li>
                      <li
                        onClick={() =>
                          window.open("/ITS/PDPA-USER-CMU-2562.pdf", "_blank")
                        }
                        className="cursor-pointer"
                      >
                        นโยบายคุ้มครองข้อมูลส่วนบุคคล มหาวิทยาลัยเชียงใหม่ พ.ศ. 2562 (CMU Privacy Policy)
                      </li>
                    </ul>
                  )}
                  {activeTab === "regulations" && (
                    <ul className="list-disc text-[#5eafd2] font-medium ">
                      <li
                        onClick={() => window.open("/ITS/SC.pdf", "_blank")}
                        className="cursor-pointer"
                      >
                        ข้อบังคับมหาวิทยาลัยเชียงใหม่
                        ว่าด้วยการบริหารจงานและการให้บริการผ่านระบบดิจิทัล
                        พ.ศ.2564
                      </li>
                    </ul>
                  )}
                  {activeTab === "laws" && (
                    <>
                      <ul className="list-disc text-[#5eafd2] font-medium ">
                        <li
                          onClick={() =>
                            window.open("/ITS/PDPA-COM-2550.pdf", "_blank")
                          }
                          className="cursor-pointer"
                        >
                          พ.ร.บ.คอมพิวเตอร์ พ.ศ. 2550
                        </li>
                        <li
                          onClick={() =>
                            window.open("/ITS/PDPA-COM-2560.pdf", "_blank")
                          }
                          className="cursor-pointer"
                        >
                          พ.ร.บ.คอมพิวเตอร์ พ.ศ. 2560
                        </li>
                        <li
                          onClick={() =>
                            window.open("/ITS/PDPA-SC.pdf", "_blank")
                          }
                          className="cursor-pointer"
                        >
                          พระราชบัญญัติการรักษาความปลอดภัยมั่นคงไซเบอร์ พ.ศ.
                          2562
                        </li>
                        <li
                          onClick={() =>
                            window.open("/ITS/PDPA-USER-2562.pdf", "_blank")
                          }
                          className="cursor-pointer"
                        >
                          พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                        </li>
                      </ul>
                    </>
                  )}
                </Fancybox>
              </div>
            </div>
          </div>

          <div className=" flex flex-col items-center justify-center text-center md:mt-0 mt-10 pb-[100px]">
            <div className="text-2xl font-bold">
              หน่วยกายภาพ สิ่งแวดล้อมและเทคโนโลยีสารสนเทศ
            </div>
            <div>
              155 หมู่ที่ 5 ตำบล แม่เหียะ อำเภอเมืองเชียงใหม่ เชียงใหม่ 50200
            </div>
            <div>โทร. 053-948018, 053-948045</div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
